import { useState, useEffect } from 'react'
import { NavLink } from "react-router";
import MenuIcon from '@mui/icons-material/Menu';
import './site_navigation.css'
import './site_navigation_desktop.css'


export function ToggleMenuBtn({ handleClick }) { //, disableInd
  return (
    <MenuIcon onClick={handleClick} id="mobile-nav-hamburger-btn" className={"mobile-nav-toggle mobile-only"} />
  )
}

export function SiteNavBrand({ handleClick }) {
  return (
    <a href="/" onClick={handleClick} className="site-nav-brand">
      <img className="logo-banner" src="/img/brand/crochetedly_logo.jpg" />
    </a>
  )
}


export function ResponsiveSiteNav({ handleNavInput, navLayout }) {

  return (
    <nav id="crochetedly-nav" className={"crochetedly-nav " + navLayout}>
        {/* <SiteNavBrand onClick={handleNavInput} /> */}
            <div className="root-nav-links">
              <NavLink className={"crochetedly-navlink " + navLayout} onClick={handleNavInput} to="/" end>HOME</NavLink>
              <NavLink className={"crochetedly-navlink " + navLayout} onClick={handleNavInput} to="/portfolio">PORTFOLIO</NavLink>
              <NavLink className={"crochetedly-navlink " + navLayout} onClick={handleNavInput} to="/shop">SHOP</NavLink>
              <NavLink className={"crochetedly-navlink " + navLayout} onClick={handleNavInput} to="/commissions">COMMISSIONS</NavLink>
              <NavLink className={"crochetedly-navlink " + navLayout} onClick={handleNavInput} to="/socials">SOCIALS</NavLink> 
            </div>
        </nav>
  )
}